import athenaClient from "lib/axios/clients";
import { REACT_APP_HERMES_URL } from "resources/constants";

const getMyTenants = (params) => {
  const config = {
    method: "GET",
    url: `${REACT_APP_HERMES_URL}/me/athena_tenants`,
    params,
  };

  return athenaClient(config);
};

export const getMe = async () => {
  const config = {
    method: "GET",
    url: `${REACT_APP_HERMES_URL}/me`,
  };

  const result = await athenaClient(config);
  return result.data;
};

export default getMyTenants;
